module.exports = __webpack_public_path__ + "img/PogAWWA.4ab7351b.png";